webpackJsonp([70144966829960],{

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(104);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _bloomer = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContactPage(_ref) {
	  var _ref$isSubmitted = _ref.isSubmitted,
	      isSubmitted = _ref$isSubmitted === undefined ? false : _ref$isSubmitted;
	
	  /* eslint-disable no-restricted-globals */
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _bloomer.Hero,
	      { isColor: 'info' },
	      _react2.default.createElement(
	        _bloomer.HeroBody,
	        null,
	        _react2.default.createElement(
	          _bloomer.Container,
	          null,
	          _react2.default.createElement(
	            _bloomer.Title,
	            null,
	            'We\'d love to hear from you!'
	          ),
	          _react2.default.createElement(
	            _bloomer.Subtitle,
	            null,
	            'Send us a message using the form below and we\'ll get back to you as soon as we can!'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _bloomer.Section,
	      null,
	      _react2.default.createElement(
	        _bloomer.Container,
	        null,
	        isSubmitted ? _react2.default.createElement(
	          _bloomer.Notification,
	          { isColor: 'primary' },
	          'Got it! Thanks for the message!\xA0',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            'Go Back'
	          )
	        ) : null,
	        _react2.default.createElement(
	          'form',
	          {
	            action: 'https://formspree.io/' + ("ecomchicagoevents@gmail.com"),
	            method: 'post'
	          },
	          _react2.default.createElement(
	            _bloomer.Field,
	            null,
	            _react2.default.createElement(
	              _bloomer.Label,
	              null,
	              'Name:'
	            ),
	            _react2.default.createElement(
	              _bloomer.Control,
	              null,
	              _react2.default.createElement(_bloomer.Input, { placeholder: 'Your Name', name: 'name' })
	            )
	          ),
	          _react2.default.createElement(
	            _bloomer.Field,
	            null,
	            _react2.default.createElement(
	              _bloomer.Label,
	              null,
	              'Email Address:'
	            ),
	            _react2.default.createElement(
	              _bloomer.Control,
	              null,
	              _react2.default.createElement(_bloomer.Input, { placeholder: 'Your Email Address', name: '_replyto' })
	            )
	          ),
	          _react2.default.createElement(
	            _bloomer.Field,
	            null,
	            _react2.default.createElement(
	              _bloomer.Label,
	              null,
	              'Message:'
	            ),
	            _react2.default.createElement(
	              _bloomer.Control,
	              null,
	              _react2.default.createElement(_bloomer.TextArea, { placeholder: 'How can we help?', name: 'message' })
	            )
	          ),
	          _react2.default.createElement('input', {
	            type: 'hidden',
	            name: '_next',
	            value: '//ecomchicago.com/contact-success'
	          }),
	          _react2.default.createElement(
	            _bloomer.Button,
	            { type: 'submit', isColor: 'danger' },
	            'Submit'
	          )
	        )
	      )
	    )
	  );
	}
	
	ContactPage.defaultProps = {
	  isSubmitted: false
	};
	
	ContactPage.propTypes = {
	  isSubmitted: _propTypes2.default.bool
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContactPage = __webpack_require__(238);
	
	var _ContactPage2 = _interopRequireDefault(_ContactPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Contact() {
	  return _react2.default.createElement(_ContactPage2.default, null);
	}
	
	Contact.defaultProps = {};
	
	Contact.propTypes = {};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-232a9e311c67d19d8aa7.js